// -----------------------------------------------------------------------------
// ContactPage — Page de contact (WhatsApp, email, FAQ)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../../i18n/translations";
import { getColors } from "../../styles/theme";
import { Ic, ICONS } from "../Icons";

export default function ContactPage({ lang, dark, accent }) {
  const t = T[lang];
  const { textPrimary, textSecondary, borderColor } = getColors(dark);

  return (
    <div className="slide-in">
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:22, fontWeight:800, color:textPrimary }}>{t.contactTitle}</h1>
        <p style={{ color:textSecondary, fontSize:12, marginTop:3 }}>{t.contactSubtitle}</p>
      </div>

      <div className="card" style={{ padding:"24px", marginBottom:16, textAlign:"center", background:`linear-gradient(135deg,${accent}10,rgba(247,147,30,.08))`, borderColor:`${accent}25` }}>
        <div style={{ width:56, height:56, background:`linear-gradient(135deg,${accent},#f7931e)`, borderRadius:15, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px" }}>
          <Ic d={ICONS.box} size={28} color="#fff" />
        </div>
        <div style={{ fontSize:18, fontWeight:800, color:textPrimary, marginBottom:2 }}>StockPro by VisualisPro</div>
        <div style={{ fontSize:12, color:textSecondary, marginBottom:4 }}>Agence Web & Design · Virton, Belgique</div>
        <div style={{ fontSize:12, color:accent }}>visualispro.be</div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <a
          href="https://wa.me/32465952862?text=Bonjour+VisualisPro,+j'ai+une+question+concernant+StockPro."
          target="_blank"
          rel="noreferrer"
          className="card glow-btn"
          style={{ padding:"22px", textDecoration:"none", display:"flex", flexDirection:"column", alignItems:"center", gap:10, borderColor:"rgba(37,211,102,.25)", cursor:"pointer" }}
        >
          <div style={{ width:48, height:48, background:"rgba(37,211,102,.12)", borderRadius:13, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <Ic d={ICONS.phone} size={24} color="#25D366" />
          </div>
          <div style={{ fontWeight:700, color:textPrimary, fontSize:15 }}>{t.contactWhatsApp}</div>
          <div style={{ fontSize:12, color:"#25D366" }}>+32 465 95 28 62</div>
        </a>
        <a
          href="mailto:contact@visualispro.be?subject=Support StockPro"
          className="card glow-btn"
          style={{ padding:"22px", textDecoration:"none", display:"flex", flexDirection:"column", alignItems:"center", gap:10, borderColor:`${accent}25`, cursor:"pointer" }}
        >
          <div style={{ width:48, height:48, background:`${accent}15`, borderRadius:13, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <Ic d={ICONS.mail} size={24} color={accent} />
          </div>
          <div style={{ fontWeight:700, color:textPrimary, fontSize:15 }}>{t.contactEmail}</div>
          <div style={{ fontSize:12, color:accent }}>contact@visualispro.be</div>
        </a>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        {[
          { label:t.contactHours, val:t.contactHoursVal, icon:ICONS.sun, color:"#f59e0b" },
          { label:t.contactResponseTime, val:t.contactResponseVal, icon:ICONS.refresh, color:"#10b981" },
        ].map((item, i) => (
          <div key={i} className="card" style={{ padding:"16px 18px", display:"flex", alignItems:"center", gap:12 }}>
            <div style={{ width:38, height:38, background:`${item.color}15`, borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <Ic d={item.icon} size={18} color={item.color} />
            </div>
            <div>
              <div style={{ fontSize:10, color:textSecondary, textTransform:"uppercase", letterSpacing:"1px", marginBottom:3 }}>{item.label}</div>
              <div style={{ fontSize:13, fontWeight:700, color:textPrimary }}>{item.val}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="card" style={{ padding:"20px" }}>
        <div style={{ fontWeight:700, color:textPrimary, fontSize:14, marginBottom:14 }}>Questions fréquentes</div>
        {[
          { q:"🔒 Mes données sont-elles sécurisées ?", a:"Oui. Vos données sont isolées dans Firebase Firestore avec des règles de sécurité strictes. Aucun autre client ne peut accéder à vos données." },
          { q:"📱 Je change d'appareil, mes données sont perdues ?", a:"Non ! Avec Firebase, vos données sont synchronisées sur le cloud. Connectez-vous depuis n'importe quel appareil avec le même email." },
          { q:"🗑️ J'ai supprimé un produit par erreur ?", a:"Pas de panique ! Nous utilisons le Soft Delete. Contactez-nous et nous restaurons votre produit en quelques minutes." },
        ].map((item, i) => (
          <div key={i} style={{ padding:"13px 15px", background:dark?"rgba(255,255,255,.02)":"rgba(0,0,0,.03)", borderRadius:10, marginBottom:8, border:`1px solid ${borderColor}` }}>
            <div style={{ fontWeight:600, color:textPrimary, fontSize:13, marginBottom:5 }}>{item.q}</div>
            <div style={{ color:textSecondary, fontSize:12 }}>{item.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
